import React, {Component} from 'react';
import { Card, CardBody, CardImage, CardText, CardTitle, Col, Fa} from "mdbreact";
import {Link} from "react-router-dom";
import { IMAGE_URL} from "../../config/Config";

export default class Merchant2 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        const { merchantObj } = this.props;
        return (
                <Col md="4">
                    <Card className="w-100 mb-5 rtl merchant-item">

                        <CardImage tag="div">

                            <Link to={`/merchant/${merchantObj.id}`} className='mt-4'>
                                <img src={IMAGE_URL + merchantObj.cover} className="w-100" style={{height:240}} alt={merchantObj.name} />
                            </Link>

                        </CardImage>


                        <CardBody>

                            <div className="d-flex justify-content-end flex-wrap">
                               <div className="mr-auto p-2">
                                   <CardTitle><Link to={`/merchant/${merchantObj.id}`} >{merchantObj.name}</Link></CardTitle>
                                   {/*<CardText>{merchantObj.short_desc} </CardText>*/}
                                   <CardText>

                                       {(merchantObj.short_desc.length > 40) ? `${merchantObj.short_desc.substring(0, 40)}...` : `${merchantObj.short_desc}`}

                                   </CardText>
                               </div>
                                {/*<div className="p-2"><img src={IMAGE_URL+merchantObj.logo} alt={merchantObj.name} style={{width:50, height:50}}/> </div>*/}
                                <div className="align-self-center" >
                                    <Link to={`/merchant/${merchantObj.id}`}><Fa icon='chevron-left' style={{color:"#f6581d", fontSize:"20px"}}/> </Link>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/merchants/Merchant2.js